import React, { Fragment, useEffect, useState } from "react";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link, Redirect } from "react-router-dom";
import { useFormik } from "formik";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
// eslint-disable-next-line
import Auth from "j-toker";
import $ from "jquery";

import { loginSchema } from "../../../src/features/auth/schemas/index.js";

import PageBg from "../../../src/assets/images/auth-bg.png";
import Logo from "../../../src/assets/images/logo.png";

import "./login.scss";
import ForgetModal from "../../components/modal/ForgetModal.js";
import { authUrl2 } from "../../api/Constants.js";
import { signin } from "../../jtoker.js";
import { set_user } from "../../redux/actions/AuthAction.js";
import { set_page_state } from "../../redux/actions/PageStateAction.js";
import { set_store } from "../../redux/actions/CreateStoreAction.js";
import ResetPasswordModal from "../../components/modal/resetPasswordModal/ResetPasswordModal.js";

const NewLoginPage = (props) => {
  const { history } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [userType, setUserType] = useState("");
  const [auth, setAuth] = useState(true);
  const [showModal, setShowModal] = useState(false);

  let message = "";

  useEffect(() => {
    document.title = "Login";
  }, []);

  useEffect(() => {
    const authenticated = localStorage.getItem("access_token");
    if (authenticated) {
      setAuth(false);
    } else {
      localStorage.clear();
      setAuth(true);
    }
    return () => {
      setAuth(true);
    };
  }, []);

  $.auth.configure({
    apiUrl: authUrl2,
  });

  const showToastError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const showToastSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const handleSubmit = (values) => {
    setUserType("");
    setLoading(true);
    setRedirect(false);

    signin({ ...values, role: "vendor" })
      .then((response) => {
        props.set_page_state({ pageState: { id: 1 } });
        props.set_store({ store: {} });
        setLoading(false);

        if (response.data.roles.includes("vendor")) {
          localStorage.setItem(
            "access_token",
            $.auth.retrieveData("authHeaders")["access-token"],
          );
          localStorage.setItem(
            "client",
            $.auth.retrieveData("authHeaders").client,
          );
          localStorage.setItem("uid", $.auth.retrieveData("authHeaders").uid);
          setUserType("vendor");
          props.set_user({ isSignedIn: true, user: $.auth.user });
          message = "Signed in successfully";
          showToastSuccess();
          // setRedirect(true);
          history.replace("/vendor");
        } else if (response.data.roles.includes("customer")) {
          localStorage.setItem(
            "access_token",
            $.auth.retrieveData("authHeaders")["access-token"],
          );
          localStorage.setItem(
            "client",
            $.auth.retrieveData("authHeaders").client,
          );
          localStorage.setItem("uid", $.auth.retrieveData("authHeaders").uid);
          setUserType("customer");
          props.set_user({ isSignedIn: true, user: $.auth.user });
          message = "Signed in successfully";
          showToastSuccess();
          props.set_page_state({ pageState: { id: 2 } });
          props.set_store({ store: {} });
          history.replace({
            pathname: "/vendor/onboarding",
            state: { type: "customer" },
          });
        } else if (response.data.roles.includes("admin")) {
          message = "Admin can't login as Vendor";
          showToastError();
        }
      })
      .fail((error) => {
        setLoading(false);
        setRedirect(false);
        if (error.data?.errors?.base) {
          message = error.data?.errors?.full_messages[0];
          showToastError();
        } else if (!error.data.errors) {
          message = "Network Error!";
          showToastError();
        } else {
          message = error.data.errors[0];
          showToastError();
        }
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    onSubmit: handleSubmit,
  });

  // Redirect Logic
  if (auth === false && userType === "vendor") {
    return <Redirect push to="/vendor" />;
  } else if (auth === false && userType === "customer") {
    return (
      <Redirect
        push
        to={{ pathname: "/create-store", state: { type: "customer" } }}
      />
    );
  }

  return (
    <Fragment>
      <div
        className="login-wrapper"
        style={{ backgroundImage: `url(${PageBg})` }}
      >
        <div className="login-overlay" />

        <Container maxWidth="sm" className="login-container">
          <Paper
            elevation={6}
            className={`login-paper ${isMobile ? "mobile" : ""}`}
          >
            <Box className="login-logo">
              <img src={Logo} alt="Logo" className={isMobile ? "mobile" : ""} />
            </Box>

            <Typography align="center" gutterBottom className="login-title">
              Log in to continue
            </Typography>

            <form onSubmit={formik.handleSubmit} className="login-form">
              <Box className={`fields ${isMobile ? "mobile" : ""}`}>
                <TextField
                  name="email"
                  type="email"
                  placeholder="Enter your email address"
                  fullWidth
                  variant="outlined"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <TextField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  fullWidth
                  variant="outlined"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? (
                            <BsEye size="1.5em" />
                          ) : (
                            <BsEyeSlash size="1.5em" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <ResetPasswordModal />

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size={isMobile ? "medium" : "large"}
                  fullWidth
                  disabled={loading}
                >
                  {loading ? (
                    <ClipLoader color="#fff" loading size={20} />
                  ) : (
                    "Continue"
                  )}
                </Button>
              </Box>
            </form>

            <Typography align="center" className="login-footer">
              Don't have an account?{" "}
              <Link
                to="/register"
                style={{ color: theme.palette.primary.main }}
              >
                Register Now!
              </Link>
            </Typography>
          </Paper>
        </Container>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  width: state.layout.screenWidth,
});

const mapDispatchToProps = {
  set_user,
  set_page_state,
  set_store,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewLoginPage),
);
